import { FC } from 'react';
import SimpleMenu from 'components/SimpleMenu';
import { ApprovalPersonnel } from 'TeamModule/constants/approval';

export interface DataDeletionBulkActionMenuProps {
  target: HTMLElement;
  mode: 'approve' | 'unapprove';
  onClose: VoidFunction;
  onApprove?: (type: ApprovalPersonnel) => void;
  onUnapprove?: (type: ApprovalPersonnel) => void;
}

export const DataDeletionBulkActionMenu: FC<DataDeletionBulkActionMenuProps> = ({
  target,
  mode,
  onClose,
  onApprove,
  onUnapprove,
}) => {
  const items =
    mode === 'approve'
      ? [
          {
            label: 'Developer',
            onClick: () => onApprove?.(ApprovalPersonnel.Developer),
          },
          {
            label: 'Support',
            onClick: () => onApprove?.(ApprovalPersonnel.Support),
          },
        ]
      : [
          {
            label: 'Developer',
            onClick: () => onUnapprove?.(ApprovalPersonnel.Developer),
          },
          {
            label: 'Support',
            onClick: () => onUnapprove?.(ApprovalPersonnel.Support),
          },
        ];

  return <SimpleMenu anchorEl={target} items={items} handleClose={onClose} />;
};

export default DataDeletionBulkActionMenu;
